<template>
  <el-col
    class="text-left distant-message pl-1"
  >
    <p style="white-space: pre-wrap">
      {{ comment.body }}
    </p>
    <footer class="blockquote-footer">
      <img
        src="@/assets/avatar.png"
        width="25px"
        class="img-thumbnail"
      > <cite>{{ comment.author.name }}</cite> - {{ formatDate(comment.created_at) }}<br>
      <attachment
        v-for="attachment in comment.attachments"
        :key="attachment.id"
        :attachment="attachment"
        style="padding-bottom: 2px;"
      />
    </footer>
  </el-col>
</template>
<script lang="ts">

import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { TicketComment } from '@/types/graphql'
import Attachment from './Attachment.vue'

import { formatDate } from '@/lib/date'

@Component({
  components: {
    Attachment
  }
})
export default class extends Vue {
  @Prop({ required: true }) private comment!: TicketComment

  private formatDate = formatDate
}
</script>
<style scoped>
.distant-message{
  border-left: 2px solid red;
  font-weight: 400;
  padding: 5px !important;
  border-radius: 0;
  background-color: hsla(0, 100%, 100%, 0.8);
}

.distant-message p{
  font-size: .9rem;
}

.blockquote-footer{
  font-style: italic
}
</style>
